import { h, Component } from 'preact';
import questionsData from '../../data/questions';
import weldshopData from '../../data/weldshop';
import assetData from '../../data/assets';
import { getPaths as getAnimPaths } from '../../components/animsequence';

const SRC_ROOT = '/assets/anim';
const srcQuestionsDefault = `${SRC_ROOT}/questions/default`;
// const srcQuestionsActive = `${SRC_ROOT}/questions/active`;
const srcLeaktest = `${SRC_ROOT}/leaktest`;
const idLeaktestA = `weldshop_pipeline_Flow_animationA`;
const idLeaktestB = `weldshop_pipeline_Flow_animationB`;

export default class AutoPreload extends Component {
  constructor (props) {
    super(props);

    if (typeof window === 'undefined') {
      return;
    }

    this.preload = this.preload.bind(this);

    const instances = (typeof props.instances === 'number' && props.instances > 0) ? props.instances : 1;
    
    for (let i = 0; i < instances; i++) {
      this.preload();
    }
  }

  getPaths () {
    const paths = [];

    questionsData.forEach(({ anim, frames, startFrame, options }) => {
      paths.push(...getAnimPaths({ id: anim, src: srcQuestionsDefault, frames, startFrame }));

      // options.forEach(({ anim, frames, startFrame }) =>
      //   paths.push(...getAnimPaths({ id: anim, src: srcQuestionsActive, frames, startFrame }))
      // );
    });

    paths.push(
      ...assetData.filter(src => src !== '/assets/video.mp4'),
      ...getAnimPaths({ id: idLeaktestA, src: srcLeaktest, frames: 100 }),
      ...getAnimPaths({ id: idLeaktestB, src: srcLeaktest, frames: 100 })
    );

    return paths;
  }

  preload () {
    if (!this.remainingPaths) {
      this.remainingPaths = this.getPaths();
    }

    const total = this.remainingPaths.length;

    if (!total) {
      return;
    }

    const path = this.remainingPaths.shift();
    const ext = path.slice(-4);

    if (ext === '.mp4') {
      const video = document.createElement('video');

      video.addEventListener('canplaythrough', this.preload);
      video.addEventListener('error', this.preload);
      video.setAttribute('preload', 'auto');
      video.setAttribute('src', path);

      if (video.load) {
        video.load();
      }
    }

    else if (ext === '.png' || ext === '.jpg' || ext === '.gif') {
      const img = new Image();

      img.addEventListener('load', this.preload);
      img.addEventListener('error', this.preload);
      img.src = path;
    }
  }

  render () {
    return null;
  }
}



// WEBPACK FOOTER //
// ./components/autopreload/index.js